import React from 'react';
import {connect} from "react-redux";

import {NoRecord} from 'components/common/app';
import {CardContainer, Input, Button, Tab, Image, Player} from 'components/common/uiKit';

import {serverUrl, apiUrl} from 'services/network';


class MainLesson extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            lessonId: 0,
            title: '',
            data: []
        };

    }

    componentDidMount() {
        this.linkProps()
    }

    linkProps() {
        const {lessonId, title, details} = this.props;
        this.setState({lessonId, data: details, title});
    }

    render() {
        const {data, title} = this.state;

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.App.Lesson.Main;

        if (!data || data.length == 0)
            return (
                <NoRecord message='MainLesson'/>
            );

        return (
            <CardContainer>
                <h3 className='color-primary pb-2'>
                    {title}
                </h3>
                {data.map(item => {
                    const content = item.content.split("\\n").map((text, i) => i ? [<br/>, text] : text);
                    switch (item.type) {
                        case 1:
                            return (
                                <p className='font-13 list-bottom-separator pt-3 pb-3'
                                   style={{whiteSpace: 'pre-line'}}>
                                    {content}
                                </p>
                            );
                        case 2:
                            const image = serverUrl + content;
                            return (
                                <div className='list-bottom-separator pt-2  pb-2'>
                                    <Image src={image} style={{width: '100%', height: '100%', borderRadius: 20}}/>
                                </div>
                            );
                        case 3:
                            const url = `${apiUrl}/Media/Get?address=${content}`;
                            return (
                                <Player url={url}/>
                            );
                        case 4:
                            return (
                                <div className='list-bottom-separator pt-2  pb-2'>
                                    <div dangerouslySetInnerHTML={{__html: item.content}}>
                                    </div>
                                </div>
                            );
                    }
                })}
            </CardContainer>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(MainLesson);
